// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-main-image-wrapper[data-v-a3b06ec4]{border-radius:2px;position:relative;top:-90px;right:16px;margin-left:auto;width:75px;height:75px;border:1px solid #dfe2e9;background-color:#fff;padding:8px;border-radius:8px;display:flex;justify-content:center;align-items:center}.provider-main-image[data-v-a3b06ec4]{border-radius:2px;width:100%;height:100%;-o-object-fit:contain;object-fit:contain;background-color:#fff}", ""]);
// Exports
module.exports = exports;
